import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import _objectWithoutProperties from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/objectWithoutProperties.js";
import "core-js/modules/es7.array.includes";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
var _excluded = ["showLoading", "onLogin", "jumpUrl"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import atom from '@tencent/vft-atom';
import Clipboard from '@tencent/vft-common/clipboard';
import env from '@tencent/vft-common/env';
import login from '@tencent/vft-common/login';
import openApp from '@tencent/vft-common/openapp';
import util from '@tencent/vft-common/util';
import vueCompat from '@tencent/vue-compat';
import { hasOwnProperty } from "../utils";
import logger from "./logger";
import loginConfig from "./loginConfig";
import { handleDirectives } from "./report";
import { delay } from "./util";
var defaultDescText = 'QQ和微信登录是两个独立账号，VIP身份不互通，登录前请确认你的常用账号。';
// 能登录微信
var wxloginWhiteList = ['app', 'wechat', 'weishi'];
// 能拉起腾讯视频
var appLaunchWhiteList = ['wechat', 'mqq', 'app', 'qqbrowser'];
var instance;
export default vueCompat.useWrap({
  name: 'LoginPanelComponent',
  directives: {
    report: {
      bind: function bind(el, binding) {
        handleDirectives(el, binding, 'bind');
      },
      update: function update(el, binding) {
        handleDirectives(el, binding, 'update');
      },
      unbind: function unbind(el, binding) {
        handleDirectives(el, binding, 'unbind');
      }
    }
  },
  data: function data() {
    return {
      appName: '腾讯视频',
      visible: false,
      // 是否显示登录弹窗
      desc: '',
      // 副标题展示
      jumpUrl: '',
      // 登录完成后的跳转地址
      pageUrl: location.href,
      // 页面地址
      isLogin: false,
      // 是否已登录
      isLoginExpired: false,
      // 登录态已过期
      loginType: '',
      // 当前登录类型
      enableQQLogin: !env.isMqq,
      // 能否登录QQ
      enableWechatLogin: env.isApp || env.isTenvideoUnion,
      // 能否登录微信
      enableOpenApp: false,
      // 能否拉起腾讯视频
      inWxMiniApp: false,
      // 是否在微信小程序内
      env: env.app,
      // 当前环境，wechat
      forceReload: true,
      // 页面回退时，是否强制刷新页面
      isPrivateMode: false,
      // 隐私模式
      isInIframe: false,
      // 兼容 iframe
      isAgreementChecked: false,
      agreement: {
        user: 'https://m.v.qq.com/about/privacy.html',
        privacy: 'https://privacy.qq.com/document/priview/3fab9c7fc1424ebda42c3ce488322c8a',
        kidPrivacy: 'https://privacy.qq.com/mb/policy/kids-privacypolicy',
        personalInfo: 'https://privacy.qq.com/document/preview/18f3ac8cb4364ed8b2ba596a9bfe3111',
        thirdInfo: 'https://privacy.qq.com/document/preview/ba4294dc9d4a45a89f3d682eb07a489b'
      }
    };
  },
  computed: {
    canLogin: function canLogin() {
      return this.enableWechatLogin || this.enableQQLogin;
    },
    descText: function descText() {
      if (this.isPrivateMode) {
        return '当前环境cookie已被您设置禁用，无法正常使用登录服务，请您重新打开后重试。您也可以前往腾讯视频App使用本功能或参与本活动。';
      }
      if (env.isMqq) {
        return "\u5982\u9700\u5207\u6362\u5FAE\u4FE1\u8D26\u53F7\uFF0C".concat(this.enableOpenApp ? '点击打开腾讯视频，即可使用微信登录；' : '可点击复制链接，发送给任意微信好友，并点击链接，即可登录微信。', "\u5982\u9700\u5207\u6362\u5176\u4ED6QQ\u8D26\u53F7\uFF0C\u53EF\u5728QQ\u3010\u8BBE\u7F6E\u3011\u4E2D\u5207\u6362\u3002").concat(defaultDescText);
      }
      if (env.isWechat && !this.enableWechatLogin) {
        return "\u5982\u9700\u5207\u6362\u5FAE\u4FE1\u8D26\u53F7\uFF0C\u8BF7\u5728\u5FAE\u4FE1\u3010\u8BBE\u7F6E\u3011\u2014\u3010\u5207\u6362\u8D26\u53F7\u3011\u4E2D\u5207\u6362\u767B\u5F55\u8D26\u53F7\u3002".concat(defaultDescText);
      }
      if (this.enableWechatLogin && this.enableQQLogin) {
        return defaultDescText;
      }
      if (this.enableWechatLogin || this.enableQQLogin) {
        var loginTypeName = this.enableWechatLogin ? '微信' : 'QQ';
        var disableLoginTypeName = this.enableWechatLogin ? 'QQ' : '微信';
        return "\u5F53\u524D\u73AF\u5883\u53EA\u652F\u6301\u767B\u5F55".concat(loginTypeName, "\u8D26\u53F7\uFF0C\u5982\u9700\u767B\u5F55").concat(disableLoginTypeName, "\u8D26\u53F7\uFF0C\u53EF\u70B9\u51FB<span id=\"clipboard\" style=\"color: #ff6022\">\u590D\u5236\u94FE\u63A5</span>\uFF0C\u53D1\u9001\u7ED9\u4EFB\u610F").concat(disableLoginTypeName, "\u597D\u53CB\uFF0C\u5E76\u70B9\u51FB\u94FE\u63A5\uFF0C\u5373\u53EF\u767B\u5F55").concat(disableLoginTypeName, "\u3002").concat(defaultDescText);
      }
      return "\u5F53\u524D\u73AF\u5883\u4E0D\u652F\u6301QQ\u8D26\u53F7\u548C\u5FAE\u4FE1\u8D26\u53F7\u767B\u5F55\uFF0C".concat(this.enableOpenApp ? '请点击打开腾讯视频，' : '请复制链接到微信或者QQ发送给任意好友，再次点击链接', "\u5373\u53EF\u4F7F\u7528\u8D26\u53F7\u767B\u5F55\u3002").concat(defaultDescText);
    },
    reports: function reports() {
      var action = this.isLogin ? '切换' : '登录';
      var params = {
        f_type: 4,
        // 4 => 按纽类型
        f_module: this.isLogin ? '切换登录' : '登录'
      };
      var btnQQ = _objectSpread(_objectSpread({}, params), {}, {
        f_resource: !this.enableQQLogin && env.isMqq ? "QQ\u65E0\u6CD5".concat(action, " (QQ\u5185)") : "QQ".concat(action, "\u6309\u7EBD")
      });
      var btnWechat = _objectSpread(_objectSpread({}, params), {}, {
        f_resource: !this.enableWechatLogin && env.isWechat ? "\u5FAE\u4FE1\u65E0\u6CD5".concat(action, " (\u5FAE\u4FE1\u5185)") : "\u5FAE\u4FE1".concat(action, "\u6309\u7EBD")
      });
      var btnOpenApp = _objectSpread(_objectSpread({}, params), {}, {
        f_resource: '打开腾讯视频按纽'
      });
      var btnClipboard = _objectSpread(_objectSpread({}, params), {}, {
        f_resource: '复制链接按纽'
      });
      return {
        btnQQ: btnQQ,
        btnWechat: btnWechat,
        btnOpenApp: btnOpenApp,
        btnClipboard: btnClipboard
      };
    },
    needMatchConfig: function needMatchConfig() {
      return !(env.isApp || env.isTenvideoUnion || env.isMqq || env.isWechat);
    },
    useApiLogin: function useApiLogin() {
      return env.isApp || env.isQQSports || env.isQQMusic || env.isTenvideoUnion;
    },
    btnLoginQQ: function btnLoginQQ() {
      if (this.enableQQLogin || this.env === 'mqq') {
        return this.isLogin ? '切换QQ登录' : '登录QQ';
      }
      return '无法切换QQ账号';
    },
    btnLoginWechat: function btnLoginWechat() {
      if (this.enableWechatLogin || this.env === 'wechat') {
        return this.isLogin ? '切换微信登录' : '登录微信';
      }
      return '无法使用微信登录';
    }
  },
  created: function created() {
    if (env.isWechat && (!window.WeixinJSBridge || !window.WeixinJSBridge.invoke)) {
      document.addEventListener('WeixinJSBridgeReady', this.init.bind(this), false);
    } else {
      this.init();
    }
  },
  mounted: function mounted() {
    var _this = this;
    instance = this;

    // fix 微信切换到登录界面时，手动返回页面由于页面 cache 导致页面无刷新问题
    window.addEventListener('pageshow', function (event) {
      if (event && event.persisted) {
        // 通过 foceReload=false 避免页面回退的时候，强制刷新
        // 业务可通过注册 reinit 方法，可在回退的时候触发页面异步刷新数据
        if (_this.forceReload) {
          window.location.reload();
        } else if (typeof window.reinit === 'function') {
          window.reinit();
        }
      }
    });
  },
  methods: {
    init: function init() {
      var _this2 = this;
      login.init(function () {
        _this2.isLogin = login.isLogin();
        _this2.loginType = login.loginType();
        _this2.setEnv();
      });
    },
    /**
     * 更新状态
     */updateState: function updateState(callback) {
      var _this3 = this;
      var timer = setTimeout(function () {
        callback === null || callback === void 0 ? void 0 : callback();
      }, 300);
      login.onInit( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.setEnv();
              case 2:
                clearTimeout(timer);
                _this3.isLogin = login.isLogin();
                _this3.loginType = login.loginType();
                // 微信环境下，已经有微信登录态时则不能切换微信登录
                if (env.isWechat && _this3.loginType === 'wx' && _this3.isLogin) {
                  _this3.enableWechatLogin = false;
                }
                if (typeof callback === 'function') {
                  callback();
                }
              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    },
    /**
     * 设置环境
     */setEnv: function () {
      var _setEnv = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _window;
        var config, enableWechatLogin, enableQQLogin, enableOpenApp;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // eslint-disable-next-line no-underscore-dangle
                this.inWxMiniApp = ((_window = window) === null || _window === void 0 ? void 0 : _window.__wxjs_environment) === 'miniprogram';
                this.enableQQLogin = !(env.isMqq || this.inWxMiniApp);
                this.isPrivateMode = !navigator.cookieEnabled;
                this.isAgreementChecked = false;
                if (env.isTenvideoUnion || env.isWechat && this.loginType !== 'wx' || wxloginWhiteList.includes(this.env)) {
                  this.enableWechatLogin = true;
                }
                if (appLaunchWhiteList.includes(this.env) && !this.inWxMiniApp) {
                  this.enableOpenApp = true;
                }
                if (!this.needMatchConfig) {
                  _context2.next = 11;
                  break;
                }
                _context2.next = 9;
                return loginConfig.fetch();
              case 9:
                config = _context2.sent;
                if (config) {
                  enableWechatLogin = config.enableWechatLogin, enableQQLogin = config.enableQQLogin, enableOpenApp = config.enableOpenApp;
                  this.enableWechatLogin = enableWechatLogin;
                  this.enableQQLogin = enableQQLogin;
                  this.enableOpenApp = enableOpenApp;
                }
              case 11:
                if (this.isPrivateMode) {
                  this.enableQQLogin = false;
                  this.enableWechatLogin = false;
                }
                this.checkLoginAppInstalled();
              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function setEnv() {
        return _setEnv.apply(this, arguments);
      }
      return setEnv;
    }(),
    /**
     * 检测微信是否安装，如果未安装，则置灰微信登录按钮
     *
     */checkLoginAppInstalled: function () {
      var _checkLoginAppInstalled = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _yield$atom$invoke, installed;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (env.isApp) {
                  _context3.next = 2;
                  break;
                }
                return _context3.abrupt("return");
              case 2:
                _context3.prev = 2;
                _context3.next = 5;
                return atom.invoke('isInstalled', {
                  pkgName: 'com.tencent.mm',
                  pkgUrl: 'weixin://',
                  appName: '微信'
                });
              case 5:
                _yield$atom$invoke = _context3.sent;
                installed = _yield$atom$invoke.installed;
                if (!installed) {
                  this.enableWechatLogin = false;
                }
                _context3.next = 13;
                break;
              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](2);
                logger.warn('判断微信安装状态失败', _context3.t0);
              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 10]]);
      }));
      function checkLoginAppInstalled() {
        return _checkLoginAppInstalled.apply(this, arguments);
      }
      return checkLoginAppInstalled;
    }(),
    popup: function popup() {
      var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (param) {
        var _param$jumpUrl = param.jumpUrl,
          jumpUrl = _param$jumpUrl === void 0 ? '' : _param$jumpUrl,
          iframe = param.iframe,
          onLogin = param.onLogin,
          onClose = param.onClose,
          _param$desc = param.desc,
          desc = _param$desc === void 0 ? '' : _param$desc,
          isLoginExpired = param.isLoginExpired;
        this.jumpUrl = jumpUrl;
        this.isInIframe = iframe;
        this.onLogin = onLogin;
        this.onClose = onClose;
        this.desc = desc;
        if (isLoginExpired) {
          this.isLogin = false;
        }
      }
      this.visible = true;
    },
    hide: function hide() {
      this.visible = false;
      if (typeof this.onClose === 'function') {
        this.onClose();
      }
    },
    actionLogin: function actionLogin(type) {
      var _ref2 = type === 'qq' ? this.precheckLoginQQ() : this.precheckLoginWechat(),
        isLocked = _ref2.isLocked,
        canLogin = _ref2.canLogin;
      if (isLocked) {
        return;
      }
      if (!canLogin) {
        return this.enableOpenApp ? this.launchApp() : this.clipboard();
      }
      if (env.isMqq) {
        return;
      }
      if (!this.isAgreementChecked) {
        return atom.toast('请先勾选“同意《用户协议》、《隐私政策》、《儿童隐私保护声明》、《个人信息采集清单》和《第三方信息共享清单》”', {
          duration: 1000
        } // 产品设计1秒消失
        );
      }

      var params = {
        type: type
      };
      if (this.jumpUrl) {
        params.url = this.jumpUrl;
      }
      this.isLogin ? this.switchLogin(params) : this.openLogin(params);
    },
    precheckLoginQQ: function precheckLoginQQ() {
      return {
        isLocked: env.isMqq,
        canLogin: this.enableQQLogin
      };
    },
    precheckLoginWechat: function precheckLoginWechat() {
      var enableWechatLogin = this.enableWechatLogin;
      return {
        isLocked: (env.isWechat || env.isApp) && !enableWechatLogin,
        canLogin: enableWechatLogin
      };
    },
    openLogin: function openLogin() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.doLogin(params, false);
    },
    switchLogin: function switchLogin() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.doLogin(params, true);
    },
    doLogin: function () {
      var _doLogin = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _ref3,
          _ref3$showLoading,
          showLoading,
          onLogin,
          jumpUrl,
          params,
          isSwitchLogin,
          _onLogin,
          res,
          ru,
          loginUrl,
          _args4 = arguments;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _ref3 = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {}, _ref3$showLoading = _ref3.showLoading, showLoading = _ref3$showLoading === void 0 ? env.isApp : _ref3$showLoading, onLogin = _ref3.onLogin, jumpUrl = _ref3.jumpUrl, params = _objectWithoutProperties(_ref3, _excluded);
                isSwitchLogin = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : false;
                if (!(env.isWeChatMiniProgram && util.getUrlParam('mpcookie'))) {
                  _context4.next = 4;
                  break;
                }
                return _context4.abrupt("return", login.openLogin());
              case 4:
                if (typeof onLogin === 'function') {
                  this.onLogin = onLogin;
                }
                if (jumpUrl) {
                  this.jumpUrl = jumpUrl;
                }
                if (params.type === 'wx' && !this.enableWechatLogin) {
                  this.visible = true;
                }
                if (showLoading) {
                  atom.showLoading('正在登录', {
                    timeout: 5000
                  });
                }
                if (!this.useApiLogin) {
                  _context4.next = 24;
                  break;
                }
                _onLogin = this.createOnLoginHandler(params);
                _context4.prev = 10;
                _context4.next = 13;
                return isSwitchLogin ? atom.switchLogin(params.type) : atom.openLogin(params);
              case 13:
                res = _context4.sent;
                _context4.next = 16;
                return delay(500);
              case 16:
                _onLogin(res);
                _context4.next = 22;
                break;
              case 19:
                _context4.prev = 19;
                _context4.t0 = _context4["catch"](10);
                logger.error('doLogin', _context4.t0);
              case 22:
                _context4.next = 25;
                break;
              case 24:
                if (this.isInIframe) {
                  ru = encodeURIComponent(window.parent.location.href);
                  loginUrl = "http://film.qq.com/weixin/login.html?ru=".concat(ru, "&type=").concat(params.type);
                  window.parent.location.href = loginUrl;
                } else {
                  login.openLogin(params);
                }
              case 25:
                atom.hideLoading();
                this.hide();
              case 27:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[10, 19]]);
      }));
      function doLogin() {
        return _doLogin.apply(this, arguments);
      }
      return doLogin;
    }(),
    logout: function logout() {
      return new Promise(function (resolve) {
        login.logout(resolve);
      });
    },
    launchApp: function () {
      var _launchApp = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var schemeUrl;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                schemeUrl = /^(tenvideo2|txvideo):\/\//.test(this.pageUrl) ? this.pageUrl : "tenvideo2://?action=10&openurl=".concat(encodeURIComponent(this.pageUrl));
                this.hide();
                _context5.next = 4;
                return openApp.launch(schemeUrl);
              case 4:
                if (_context5.sent) {
                  _context5.next = 6;
                  break;
                }
                // 拉起失败
                location.href = "https://film.qq.com/h5/app/openapp.html?openurl=".concat(encodeURIComponent(this.pageUrl), "&auto=0");
              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
      function launchApp() {
        return _launchApp.apply(this, arguments);
      }
      return launchApp;
    }(),
    clipboard: function clipboard() {
      // eslint-disable-next-line
      new Clipboard({
        text: this.pageUrl || location.href,
        success: function success() {
          atom.toast('已复制链接');
        },
        error: function error() {
          atom.toast('暂不支持复制功能，可手动分享此页面到微信打开或者直接复制该页面地址！');
        }
      });
      this.hide();
    },
    descTextClick: function descTextClick(e) {
      if (e.target.id === 'clipboard') {
        this.clipboard();
      }
    },
    createOnLoginHandler: function createOnLoginHandler() {
      var _this4 = this;
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        url = _ref4.url,
        jumpUrl = _ref4.jumpUrl;
      if (typeof this.onLogin === 'function') {
        return function (res) {
          return _this4.onLogin((res === null || res === void 0 ? void 0 : res.errCode) === 0 && res !== null && res !== void 0 && res.result ? res.result : null);
        };
      }
      var redirectUrl = url || jumpUrl;
      if (redirectUrl) {
        return function () {
          return location.href = redirectUrl;
        };
      }
      if (typeof window.reinit === 'function') {
        return function () {
          return window.reinit();
        };
      }
      return function () {
        return location.reload();
      };
    },
    openAgreement: function openAgreement(url) {
      // iframe 跳转全屏展示
      if (this.isInIframe) {
        window.parent.location.href = url;
        return;
      }
      atom.openUrl(url);
    }
  },
  install: function install(Vue) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    Object.keys(option).forEach(function (key) {
      if (hasOwnProperty(instance, key) && option[key]) {
        instance[key] = option[key];
      }
    });
    Object.assign(Vue.prototype, {
      $openLogin: function $openLogin(params) {
        instance.updateState(function () {
          var _instance = instance,
            isLogin = _instance.isLogin;
          if (env.isMqq && !instance.isLogin) {
            instance.switchLogin(_objectSpread(_objectSpread({}, params), {}, {
              type: 'qq'
            }));
          } else if (env.isBaseApp && !isLogin) {
            instance.openLogin(_objectSpread(_objectSpread({}, params), {}, {
              type: 'tv'
            }));
          } else if (env.isWeishi || env.isQQSports || env.isQQMusic || env.isKidApp || env.isTenvideoUnion || env.isWeChatMiniProgram && util.getUrlParam('mpcookie')) {
            instance.isLogin ? instance.switchLogin(params) : instance.openLogin(params);
          } else {
            instance.popup(params);
          }
        });
      },
      $switchLogin: function $switchLogin(params) {
        instance.updateState(function () {
          instance.switchLogin(params);
        });
      },
      $checkLogin: function $checkLogin(params) {
        return new Promise(function (resolve) {
          login.isStrictLogin(function (isLogin) {
            if (isLogin) {
              resolve(true);
            } else {
              resolve(false);
              instance.updateState(function () {
                instance.isLoginExpired = login.isLogin() && !isLogin;
                instance.isLogin = login.isLogin();
                instance.popup(params);
              });
            }
          });
        });
      }
    });
  }
});